"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errors = void 0;
const core_1 = require("@smash-sdk/core");
const CreateAccountLinkError_1 = require("./types/CreateAccountLink/CreateAccountLinkError");
const CreateAccountLinkError_2 = require("./types/CreateAccountLink/CreateAccountLinkError");
const CreateAccountLinkError_3 = require("./types/CreateAccountLink/CreateAccountLinkError");
const CreateAccountLinkError_4 = require("./types/CreateAccountLink/CreateAccountLinkError");
const CreateAccountLinkError_5 = require("./types/CreateAccountLink/CreateAccountLinkError");
const CreateAccountLinkError_6 = require("./types/CreateAccountLink/CreateAccountLinkError");
const CreateAccountLinkError_7 = require("./types/CreateAccountLink/CreateAccountLinkError");
const CreateAccountTeamLinkError_1 = require("./types/CreateAccountTeamLink/CreateAccountTeamLinkError");
const CreateAccountTeamLinkError_2 = require("./types/CreateAccountTeamLink/CreateAccountTeamLinkError");
const CreateAccountTeamLinkError_3 = require("./types/CreateAccountTeamLink/CreateAccountTeamLinkError");
const CreateAccountTeamLinkError_4 = require("./types/CreateAccountTeamLink/CreateAccountTeamLinkError");
const CreateAccountTeamLinkError_5 = require("./types/CreateAccountTeamLink/CreateAccountTeamLinkError");
const CreateAccountTeamLinkError_6 = require("./types/CreateAccountTeamLink/CreateAccountTeamLinkError");
const CreateAccountTeamLinkError_7 = require("./types/CreateAccountTeamLink/CreateAccountTeamLinkError");
const CreateAccountTeamLinkError_8 = require("./types/CreateAccountTeamLink/CreateAccountTeamLinkError");
const CreateAccountTeamUserLinkError_1 = require("./types/CreateAccountTeamUserLink/CreateAccountTeamUserLinkError");
const CreateAccountTeamUserLinkError_2 = require("./types/CreateAccountTeamUserLink/CreateAccountTeamUserLinkError");
const CreateAccountTeamUserLinkError_3 = require("./types/CreateAccountTeamUserLink/CreateAccountTeamUserLinkError");
const CreateAccountTeamUserLinkError_4 = require("./types/CreateAccountTeamUserLink/CreateAccountTeamUserLinkError");
const CreateAccountTeamUserLinkError_5 = require("./types/CreateAccountTeamUserLink/CreateAccountTeamUserLinkError");
const CreateAccountTeamUserLinkError_6 = require("./types/CreateAccountTeamUserLink/CreateAccountTeamUserLinkError");
const CreateAccountTeamUserLinkError_7 = require("./types/CreateAccountTeamUserLink/CreateAccountTeamUserLinkError");
const CreateAccountTeamUserLinkError_8 = require("./types/CreateAccountTeamUserLink/CreateAccountTeamUserLinkError");
const CreateAccountUserLinkError_1 = require("./types/CreateAccountUserLink/CreateAccountUserLinkError");
const CreateAccountUserLinkError_2 = require("./types/CreateAccountUserLink/CreateAccountUserLinkError");
const CreateAccountUserLinkError_3 = require("./types/CreateAccountUserLink/CreateAccountUserLinkError");
const CreateAccountUserLinkError_4 = require("./types/CreateAccountUserLink/CreateAccountUserLinkError");
const CreateAccountUserLinkError_5 = require("./types/CreateAccountUserLink/CreateAccountUserLinkError");
const CreateAccountUserLinkError_6 = require("./types/CreateAccountUserLink/CreateAccountUserLinkError");
const CreateAccountUserLinkError_7 = require("./types/CreateAccountUserLink/CreateAccountUserLinkError");
const DeleteAccountLinkError_1 = require("./types/DeleteAccountLink/DeleteAccountLinkError");
const DeleteAccountLinkError_2 = require("./types/DeleteAccountLink/DeleteAccountLinkError");
const DeleteAccountLinkError_3 = require("./types/DeleteAccountLink/DeleteAccountLinkError");
const DeleteAccountLinkError_4 = require("./types/DeleteAccountLink/DeleteAccountLinkError");
const DeleteAccountLinkError_5 = require("./types/DeleteAccountLink/DeleteAccountLinkError");
const DeleteAccountLinkError_6 = require("./types/DeleteAccountLink/DeleteAccountLinkError");
const DeleteAccountLinkError_7 = require("./types/DeleteAccountLink/DeleteAccountLinkError");
const DeleteLinkError_1 = require("./types/DeleteLink/DeleteLinkError");
const DeleteLinkError_2 = require("./types/DeleteLink/DeleteLinkError");
const DeleteLinkError_3 = require("./types/DeleteLink/DeleteLinkError");
const DeleteLinkError_4 = require("./types/DeleteLink/DeleteLinkError");
const DeleteLinkError_5 = require("./types/DeleteLink/DeleteLinkError");
const DeleteLinkError_6 = require("./types/DeleteLink/DeleteLinkError");
const DeleteLinkError_7 = require("./types/DeleteLink/DeleteLinkError");
const GetLinkError_1 = require("./types/GetLink/GetLinkError");
const GetLinkError_2 = require("./types/GetLink/GetLinkError");
const GetLinkError_3 = require("./types/GetLink/GetLinkError");
const GetLinkError_4 = require("./types/GetLink/GetLinkError");
const GetLinkError_5 = require("./types/GetLink/GetLinkError");
const GetLinkError_6 = require("./types/GetLink/GetLinkError");
const GetLinkError_7 = require("./types/GetLink/GetLinkError");
const GetTargetError_1 = require("./types/GetTarget/GetTargetError");
const GetTargetError_2 = require("./types/GetTarget/GetTargetError");
const GetTargetError_3 = require("./types/GetTarget/GetTargetError");
const GetTargetError_4 = require("./types/GetTarget/GetTargetError");
const GetTargetError_5 = require("./types/GetTarget/GetTargetError");
const GetTargetError_6 = require("./types/GetTarget/GetTargetError");
const GetTargetError_7 = require("./types/GetTarget/GetTargetError");
const GetTeamLinkError_1 = require("./types/GetTeamLink/GetTeamLinkError");
const GetTeamLinkError_2 = require("./types/GetTeamLink/GetTeamLinkError");
const GetTeamLinkError_3 = require("./types/GetTeamLink/GetTeamLinkError");
const GetTeamLinkError_4 = require("./types/GetTeamLink/GetTeamLinkError");
const GetTeamLinkError_5 = require("./types/GetTeamLink/GetTeamLinkError");
const GetTeamLinkError_6 = require("./types/GetTeamLink/GetTeamLinkError");
const GetTeamLinkError_7 = require("./types/GetTeamLink/GetTeamLinkError");
const GetUserLinkError_1 = require("./types/GetUserLink/GetUserLinkError");
const GetUserLinkError_2 = require("./types/GetUserLink/GetUserLinkError");
const GetUserLinkError_3 = require("./types/GetUserLink/GetUserLinkError");
const GetUserLinkError_4 = require("./types/GetUserLink/GetUserLinkError");
const GetUserLinkError_5 = require("./types/GetUserLink/GetUserLinkError");
const GetUserLinkError_6 = require("./types/GetUserLink/GetUserLinkError");
const GetUserLinkError_7 = require("./types/GetUserLink/GetUserLinkError");
const ListLinksError_1 = require("./types/ListLinks/ListLinksError");
const ListLinksError_2 = require("./types/ListLinks/ListLinksError");
const ListLinksError_3 = require("./types/ListLinks/ListLinksError");
const ListLinksError_4 = require("./types/ListLinks/ListLinksError");
const ListLinksError_5 = require("./types/ListLinks/ListLinksError");
const ListTeamLinksError_1 = require("./types/ListTeamLinks/ListTeamLinksError");
const ListTeamLinksError_2 = require("./types/ListTeamLinks/ListTeamLinksError");
const ListTeamLinksError_3 = require("./types/ListTeamLinks/ListTeamLinksError");
const ListTeamLinksError_4 = require("./types/ListTeamLinks/ListTeamLinksError");
const ListTeamLinksError_5 = require("./types/ListTeamLinks/ListTeamLinksError");
const ListTeamLinksError_6 = require("./types/ListTeamLinks/ListTeamLinksError");
const ListUserLinksError_1 = require("./types/ListUserLinks/ListUserLinksError");
const ListUserLinksError_2 = require("./types/ListUserLinks/ListUserLinksError");
const ListUserLinksError_3 = require("./types/ListUserLinks/ListUserLinksError");
const ListUserLinksError_4 = require("./types/ListUserLinks/ListUserLinksError");
const ListUserLinksError_5 = require("./types/ListUserLinks/ListUserLinksError");
const ListUserLinksError_6 = require("./types/ListUserLinks/ListUserLinksError");
const LockAccountUserLinkError_1 = require("./types/LockAccountUserLink/LockAccountUserLinkError");
const LockAccountUserLinkError_2 = require("./types/LockAccountUserLink/LockAccountUserLinkError");
const LockAccountUserLinkError_3 = require("./types/LockAccountUserLink/LockAccountUserLinkError");
const LockAccountUserLinkError_4 = require("./types/LockAccountUserLink/LockAccountUserLinkError");
const LockAccountUserLinkError_5 = require("./types/LockAccountUserLink/LockAccountUserLinkError");
const LockAccountUserLinkError_6 = require("./types/LockAccountUserLink/LockAccountUserLinkError");
const LockAccountUserLinkError_7 = require("./types/LockAccountUserLink/LockAccountUserLinkError");
exports.errors = {
    CreateAccountLink: {
        InvalidParameterError: CreateAccountLinkError_2.InvalidParameterError,
        UnauthorizedError: CreateAccountLinkError_3.UnauthorizedError,
        ConflictError: CreateAccountLinkError_4.ConflictError,
        InternalServerError: CreateAccountLinkError_5.InternalServerError,
        BadGatewayError: CreateAccountLinkError_6.BadGatewayError,
        GatewayTimeoutError: CreateAccountLinkError_7.GatewayTimeoutError,
        GenericError: CreateAccountLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateAccountTeamLink: {
        InvalidParameterError: CreateAccountTeamLinkError_2.InvalidParameterError,
        UnauthorizedError: CreateAccountTeamLinkError_3.UnauthorizedError,
        NotFoundError: CreateAccountTeamLinkError_4.NotFoundError,
        ConflictError: CreateAccountTeamLinkError_5.ConflictError,
        InternalServerError: CreateAccountTeamLinkError_6.InternalServerError,
        BadGatewayError: CreateAccountTeamLinkError_7.BadGatewayError,
        GatewayTimeoutError: CreateAccountTeamLinkError_8.GatewayTimeoutError,
        GenericError: CreateAccountTeamLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateAccountTeamUserLink: {
        InvalidParameterError: CreateAccountTeamUserLinkError_2.InvalidParameterError,
        UnauthorizedError: CreateAccountTeamUserLinkError_3.UnauthorizedError,
        NotFoundError: CreateAccountTeamUserLinkError_4.NotFoundError,
        ConflictError: CreateAccountTeamUserLinkError_5.ConflictError,
        InternalServerError: CreateAccountTeamUserLinkError_6.InternalServerError,
        BadGatewayError: CreateAccountTeamUserLinkError_7.BadGatewayError,
        GatewayTimeoutError: CreateAccountTeamUserLinkError_8.GatewayTimeoutError,
        GenericError: CreateAccountTeamUserLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateAccountUserLink: {
        InvalidParameterError: CreateAccountUserLinkError_2.InvalidParameterError,
        UnauthorizedError: CreateAccountUserLinkError_3.UnauthorizedError,
        ConflictError: CreateAccountUserLinkError_4.ConflictError,
        InternalServerError: CreateAccountUserLinkError_5.InternalServerError,
        BadGatewayError: CreateAccountUserLinkError_6.BadGatewayError,
        GatewayTimeoutError: CreateAccountUserLinkError_7.GatewayTimeoutError,
        GenericError: CreateAccountUserLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteAccountLink: {
        InvalidParameterError: DeleteAccountLinkError_2.InvalidParameterError,
        UnauthorizedError: DeleteAccountLinkError_3.UnauthorizedError,
        NotFoundError: DeleteAccountLinkError_4.NotFoundError,
        InternalServerError: DeleteAccountLinkError_5.InternalServerError,
        BadGatewayError: DeleteAccountLinkError_6.BadGatewayError,
        GatewayTimeoutError: DeleteAccountLinkError_7.GatewayTimeoutError,
        GenericError: DeleteAccountLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteLink: {
        InvalidParameterError: DeleteLinkError_2.InvalidParameterError,
        UnauthorizedError: DeleteLinkError_3.UnauthorizedError,
        NotFoundError: DeleteLinkError_4.NotFoundError,
        InternalServerError: DeleteLinkError_5.InternalServerError,
        BadGatewayError: DeleteLinkError_6.BadGatewayError,
        GatewayTimeoutError: DeleteLinkError_7.GatewayTimeoutError,
        GenericError: DeleteLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetLink: {
        InvalidParameterError: GetLinkError_2.InvalidParameterError,
        UnauthorizedError: GetLinkError_3.UnauthorizedError,
        NotFoundError: GetLinkError_4.NotFoundError,
        InternalServerError: GetLinkError_5.InternalServerError,
        BadGatewayError: GetLinkError_6.BadGatewayError,
        GatewayTimeoutError: GetLinkError_7.GatewayTimeoutError,
        GenericError: GetLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTarget: {
        InvalidParameterError: GetTargetError_2.InvalidParameterError,
        UnauthorizedError: GetTargetError_3.UnauthorizedError,
        NotFoundError: GetTargetError_4.NotFoundError,
        InternalServerError: GetTargetError_5.InternalServerError,
        BadGatewayError: GetTargetError_6.BadGatewayError,
        GatewayTimeoutError: GetTargetError_7.GatewayTimeoutError,
        GenericError: GetTargetError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamLink: {
        InvalidParameterError: GetTeamLinkError_2.InvalidParameterError,
        UnauthorizedError: GetTeamLinkError_3.UnauthorizedError,
        NotFoundError: GetTeamLinkError_4.NotFoundError,
        InternalServerError: GetTeamLinkError_5.InternalServerError,
        BadGatewayError: GetTeamLinkError_6.BadGatewayError,
        GatewayTimeoutError: GetTeamLinkError_7.GatewayTimeoutError,
        GenericError: GetTeamLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUserLink: {
        InvalidParameterError: GetUserLinkError_2.InvalidParameterError,
        UnauthorizedError: GetUserLinkError_3.UnauthorizedError,
        NotFoundError: GetUserLinkError_4.NotFoundError,
        InternalServerError: GetUserLinkError_5.InternalServerError,
        BadGatewayError: GetUserLinkError_6.BadGatewayError,
        GatewayTimeoutError: GetUserLinkError_7.GatewayTimeoutError,
        GenericError: GetUserLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListLinks: {
        UnauthorizedError: ListLinksError_2.UnauthorizedError,
        InternalServerError: ListLinksError_3.InternalServerError,
        BadGatewayError: ListLinksError_4.BadGatewayError,
        GatewayTimeoutError: ListLinksError_5.GatewayTimeoutError,
        GenericError: ListLinksError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamLinks: {
        InvalidParameterError: ListTeamLinksError_2.InvalidParameterError,
        UnauthorizedError: ListTeamLinksError_3.UnauthorizedError,
        InternalServerError: ListTeamLinksError_4.InternalServerError,
        BadGatewayError: ListTeamLinksError_5.BadGatewayError,
        GatewayTimeoutError: ListTeamLinksError_6.GatewayTimeoutError,
        GenericError: ListTeamLinksError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListUserLinks: {
        InvalidParameterError: ListUserLinksError_2.InvalidParameterError,
        UnauthorizedError: ListUserLinksError_3.UnauthorizedError,
        InternalServerError: ListUserLinksError_4.InternalServerError,
        BadGatewayError: ListUserLinksError_5.BadGatewayError,
        GatewayTimeoutError: ListUserLinksError_6.GatewayTimeoutError,
        GenericError: ListUserLinksError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    LockAccountUserLink: {
        InvalidParameterError: LockAccountUserLinkError_2.InvalidParameterError,
        UnauthorizedError: LockAccountUserLinkError_3.UnauthorizedError,
        NotFoundError: LockAccountUserLinkError_4.NotFoundError,
        InternalServerError: LockAccountUserLinkError_5.InternalServerError,
        BadGatewayError: LockAccountUserLinkError_6.BadGatewayError,
        GatewayTimeoutError: LockAccountUserLinkError_7.GatewayTimeoutError,
        GenericError: LockAccountUserLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateAccountLinkError: {
        InvalidParameterError: CreateAccountLinkError_2.InvalidParameterError,
        UnauthorizedError: CreateAccountLinkError_3.UnauthorizedError,
        ConflictError: CreateAccountLinkError_4.ConflictError,
        InternalServerError: CreateAccountLinkError_5.InternalServerError,
        BadGatewayError: CreateAccountLinkError_6.BadGatewayError,
        GatewayTimeoutError: CreateAccountLinkError_7.GatewayTimeoutError,
        GenericError: CreateAccountLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateAccountTeamLinkError: {
        InvalidParameterError: CreateAccountTeamLinkError_2.InvalidParameterError,
        UnauthorizedError: CreateAccountTeamLinkError_3.UnauthorizedError,
        NotFoundError: CreateAccountTeamLinkError_4.NotFoundError,
        ConflictError: CreateAccountTeamLinkError_5.ConflictError,
        InternalServerError: CreateAccountTeamLinkError_6.InternalServerError,
        BadGatewayError: CreateAccountTeamLinkError_7.BadGatewayError,
        GatewayTimeoutError: CreateAccountTeamLinkError_8.GatewayTimeoutError,
        GenericError: CreateAccountTeamLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateAccountTeamUserLinkError: {
        InvalidParameterError: CreateAccountTeamUserLinkError_2.InvalidParameterError,
        UnauthorizedError: CreateAccountTeamUserLinkError_3.UnauthorizedError,
        NotFoundError: CreateAccountTeamUserLinkError_4.NotFoundError,
        ConflictError: CreateAccountTeamUserLinkError_5.ConflictError,
        InternalServerError: CreateAccountTeamUserLinkError_6.InternalServerError,
        BadGatewayError: CreateAccountTeamUserLinkError_7.BadGatewayError,
        GatewayTimeoutError: CreateAccountTeamUserLinkError_8.GatewayTimeoutError,
        GenericError: CreateAccountTeamUserLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateAccountUserLinkError: {
        InvalidParameterError: CreateAccountUserLinkError_2.InvalidParameterError,
        UnauthorizedError: CreateAccountUserLinkError_3.UnauthorizedError,
        ConflictError: CreateAccountUserLinkError_4.ConflictError,
        InternalServerError: CreateAccountUserLinkError_5.InternalServerError,
        BadGatewayError: CreateAccountUserLinkError_6.BadGatewayError,
        GatewayTimeoutError: CreateAccountUserLinkError_7.GatewayTimeoutError,
        GenericError: CreateAccountUserLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteAccountLinkError: {
        InvalidParameterError: DeleteAccountLinkError_2.InvalidParameterError,
        UnauthorizedError: DeleteAccountLinkError_3.UnauthorizedError,
        NotFoundError: DeleteAccountLinkError_4.NotFoundError,
        InternalServerError: DeleteAccountLinkError_5.InternalServerError,
        BadGatewayError: DeleteAccountLinkError_6.BadGatewayError,
        GatewayTimeoutError: DeleteAccountLinkError_7.GatewayTimeoutError,
        GenericError: DeleteAccountLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    DeleteLinkError: {
        InvalidParameterError: DeleteLinkError_2.InvalidParameterError,
        UnauthorizedError: DeleteLinkError_3.UnauthorizedError,
        NotFoundError: DeleteLinkError_4.NotFoundError,
        InternalServerError: DeleteLinkError_5.InternalServerError,
        BadGatewayError: DeleteLinkError_6.BadGatewayError,
        GatewayTimeoutError: DeleteLinkError_7.GatewayTimeoutError,
        GenericError: DeleteLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetLinkError: {
        InvalidParameterError: GetLinkError_2.InvalidParameterError,
        UnauthorizedError: GetLinkError_3.UnauthorizedError,
        NotFoundError: GetLinkError_4.NotFoundError,
        InternalServerError: GetLinkError_5.InternalServerError,
        BadGatewayError: GetLinkError_6.BadGatewayError,
        GatewayTimeoutError: GetLinkError_7.GatewayTimeoutError,
        GenericError: GetLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTargetError: {
        InvalidParameterError: GetTargetError_2.InvalidParameterError,
        UnauthorizedError: GetTargetError_3.UnauthorizedError,
        NotFoundError: GetTargetError_4.NotFoundError,
        InternalServerError: GetTargetError_5.InternalServerError,
        BadGatewayError: GetTargetError_6.BadGatewayError,
        GatewayTimeoutError: GetTargetError_7.GatewayTimeoutError,
        GenericError: GetTargetError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetTeamLinkError: {
        InvalidParameterError: GetTeamLinkError_2.InvalidParameterError,
        UnauthorizedError: GetTeamLinkError_3.UnauthorizedError,
        NotFoundError: GetTeamLinkError_4.NotFoundError,
        InternalServerError: GetTeamLinkError_5.InternalServerError,
        BadGatewayError: GetTeamLinkError_6.BadGatewayError,
        GatewayTimeoutError: GetTeamLinkError_7.GatewayTimeoutError,
        GenericError: GetTeamLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetUserLinkError: {
        InvalidParameterError: GetUserLinkError_2.InvalidParameterError,
        UnauthorizedError: GetUserLinkError_3.UnauthorizedError,
        NotFoundError: GetUserLinkError_4.NotFoundError,
        InternalServerError: GetUserLinkError_5.InternalServerError,
        BadGatewayError: GetUserLinkError_6.BadGatewayError,
        GatewayTimeoutError: GetUserLinkError_7.GatewayTimeoutError,
        GenericError: GetUserLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListLinksError: {
        UnauthorizedError: ListLinksError_2.UnauthorizedError,
        InternalServerError: ListLinksError_3.InternalServerError,
        BadGatewayError: ListLinksError_4.BadGatewayError,
        GatewayTimeoutError: ListLinksError_5.GatewayTimeoutError,
        GenericError: ListLinksError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListTeamLinksError: {
        InvalidParameterError: ListTeamLinksError_2.InvalidParameterError,
        UnauthorizedError: ListTeamLinksError_3.UnauthorizedError,
        InternalServerError: ListTeamLinksError_4.InternalServerError,
        BadGatewayError: ListTeamLinksError_5.BadGatewayError,
        GatewayTimeoutError: ListTeamLinksError_6.GatewayTimeoutError,
        GenericError: ListTeamLinksError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListUserLinksError: {
        InvalidParameterError: ListUserLinksError_2.InvalidParameterError,
        UnauthorizedError: ListUserLinksError_3.UnauthorizedError,
        InternalServerError: ListUserLinksError_4.InternalServerError,
        BadGatewayError: ListUserLinksError_5.BadGatewayError,
        GatewayTimeoutError: ListUserLinksError_6.GatewayTimeoutError,
        GenericError: ListUserLinksError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    LockAccountUserLinkError: {
        InvalidParameterError: LockAccountUserLinkError_2.InvalidParameterError,
        UnauthorizedError: LockAccountUserLinkError_3.UnauthorizedError,
        NotFoundError: LockAccountUserLinkError_4.NotFoundError,
        InternalServerError: LockAccountUserLinkError_5.InternalServerError,
        BadGatewayError: LockAccountUserLinkError_6.BadGatewayError,
        GatewayTimeoutError: LockAccountUserLinkError_7.GatewayTimeoutError,
        GenericError: LockAccountUserLinkError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    InvalidSdkConfigurationError: core_1.InvalidSdkConfigurationError,
    InvalidRegionOrHostError: core_1.InvalidRegionOrHostError,
    InvalidRegionError: core_1.InvalidRegionError,
    InvalidHostError: core_1.InvalidHostError,
};
